import { defineStore } from "pinia";
import NotificationApi from "@/api/NotificationApi";

export const useNotificationStore = defineStore("notification", {
  state: () => {
    return {
      notifications: [],
      notification: {},
      preferences: {}
    };
  },

  actions: {
    async getNotificationPreferences() {
      this.preferences = await NotificationApi.getNotificationPreferences();
    },
    async getNotifications(params) {
      this.notifications = (
        await NotificationApi.getNotifications(params)
      ).notifications;
    },
    async updateNotification(params) {
      this.notifications = this.notifications.filter(
        ({ id }) => id !== params.id
      );
      this.notification = await NotificationApi.updateNotification(params);
    },
    async readAllNotification(params) {
      this.notifications = (
        await NotificationApi.readAllNotification(params)
      ).notifications;
    },
    async updateNotificationPreferences(payload) {
      await NotificationApi.updateNotificationPreferences(payload);
    }
  }
});
